import { render, staticRenderFns } from "./C2wClicksByDateBarChart.vue?vue&type=template&id=bfc3c9b2&scoped=true&"
import script from "./C2wClicksByDateBarChart.vue?vue&type=script&lang=js&"
export * from "./C2wClicksByDateBarChart.vue?vue&type=script&lang=js&"
import style0 from "./C2wClicksByDateBarChart.vue?vue&type=style&index=0&id=bfc3c9b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc3c9b2",
  null
  
)

export default component.exports